import { createSelector } from "@reduxjs/toolkit";

// racine rooms
export const selectRoomsState = (state) => state.rooms;

// toutes les rooms en array
export const selectAllRooms = createSelector(
  selectRoomsState,
  (roomsState) => roomsState.allIds.map((id) => roomsState.byId[id])
);

// room par id
export const selectRoomById = (roomId) =>
  createSelector(selectRoomsState, (roomsState) => roomsState.byId[roomId]);

// rooms par status
export const selectRoomsByStatus = (status) =>
  createSelector(selectAllRooms, (rooms) =>
    rooms.filter((r) => r?.status === status)
  );

// rooms par docteur
export const selectRoomsByDoctor = (doctorId) =>
  createSelector(selectAllRooms, (rooms) =>
    rooms.filter((r) => r?.doctorId === doctorId)
  );

// rooms par patient
export const selectRoomsByPatient = (patientId) =>
  createSelector(selectAllRooms, (rooms) =>
    rooms.filter((r) => r?.patientId === patientId)
  );

// loading / error
export const selectRoomsLoading = createSelector(
  selectRoomsState,
  (roomsState) => roomsState.loading
);

export const selectRoomsError = createSelector(
  selectRoomsState,
  (roomsState) => roomsState.error
);